<template>
    <ul :class="'pagination justify-content-' + position">
        <li class="page-item" :class="{ disabled: disabledFirst }">
            <a
                    class="page-link"
                    @click="onClickFirstPage"
                    aria-label="Go to first page"
            >
                {{ firstText }}
            </a>
        </li>

        <li class="page-item" :class="{ disabled: disabledFirst }">
            <a
                    class="page-link"
                    @click="onClickPreviousPage"
                    aria-label="Go to previous page"
            >
                {{ previousText }}
            </a>
        </li>

        <li class="page-item" :class="{ displayNone: disabledLess }">
            <a
                    class="page-link"
                    @click="onClickMorePreviousPage"
                    aria-label="Go to previous page"
            >
                ...
            </a>
        </li>

        <li
                v-for="page in pages"
                class="page-item"
                :key="page.name"
                :class="{ active: isPageActive(page.name) }"
        >
            <a
                    class="page-link"
                    @click="onClickPage(page.name)"
                    :aria-label="`Go to page number ${page.name}`"
            >
                {{ page.name }}
            </a>
        </li>

        <li class="page-item" :class="{ displayNone: disabledMore }">
            <a
                    class="page-link"
                    @click="onClickMoreNextPage"
                    aria-label="Go to next page"
            >
                ...
            </a>
        </li>

        <li class="page-item" :class="{ disabled: disabledLast }">
            <a
                    class="page-link"
                    @click="onClickNextPage"
                    aria-label="Go to next page"
            >
                {{ nextText }}
            </a>
        </li>

        <li class="page-item" :class="{ disabled: disabledLast }">
            <a
                    class="page-link"
                    @click="onClickLastPage"
                    aria-label="Go to last page"
            >
                {{ lastText }}
            </a>
        </li>
    </ul>
</template>

<script>
    /**
     * @author HungNS
     */
    export default {
        name:"Pagination",
        props: {
            position: {type: String, required: false, default: "center"},
            previousText: {type: String, required: true},
            nextText: {type: String, required: true},
            firstText: {type: String, required: true},
            lastText: {type: String, required: true},
            maxVisibleButtons: {type: Number, required: false, default: 5},
            totalPages: {type: Number, required: true},
            total: {type: Number, required: true},
            perPage: {type: Number, required: true},
            currentPage: {type: Number, required: true},
        },
        computed: {
            startPage() {
                if (this.currentPage <= this.maxVisibleButtons) {
                    return 1;
                } else {
                    if (this.currentPage % this.maxVisibleButtons === 0) {
                        return this.currentPage - this.maxVisibleButtons + 1;
                    } else {
                        return parseInt(this.currentPage / this.maxVisibleButtons) * this.maxVisibleButtons + 1;
                    }
                }
            },
            endPage() {
                return Math.min(
                    this.startPage + this.maxVisibleButtons - 1,
                    this.totalPages
                );
            },
            pages() {
                const range = [];
                for (let i = this.startPage; i <= this.endPage; i++) {
                    range.push({
                        name: i,
                        isDisabled: i === this.currentPage,
                    });
                }
                return range;
            },
            disabledFirst() {
                return this.currentPage === 1;
            },
            disabledLess() {
                return this.currentPage <= 5;
            },
            disabledMore() {
                if(this.totalPages % this.maxVisibleButtons === 0){
                    return this.startPage === this.totalPages - this.maxVisibleButtons + 1;
                } else {
                    return this.startPage === (parseInt(this.totalPages / this.maxVisibleButtons) * this.maxVisibleButtons) + 1;
                }
            },
            disabledLast() {
                if (this.totalPages === 0) return true;
                return this.currentPage === this.totalPages;
            },
        },
        methods: {
            onClickFirstPage() {
                this.$emit("pagechanged", 1);
            },
            onClickPreviousPage() {
                this.$emit("pagechanged", this.currentPage - 1);
            },
            onClickMorePreviousPage() {
                const currentPage = this.currentPage - this.maxVisibleButtons < 1 ? 1 : this.currentPage - this.maxVisibleButtons;
                this.$emit("pageJump", currentPage, true, false, this.maxVisibleButtons);
            },
            onClickPage(page) {
                this.$emit("pagechanged", page);
            },
            onClickMoreNextPage() {
                const currentPage = this.currentPage + this.maxVisibleButtons > this.totalPages ? this.totalPages : this.currentPage + this.maxVisibleButtons;
                this.$emit("pageJump", currentPage, false, true, this.maxVisibleButtons);
            },
            onClickNextPage() {
                this.$emit("pagechanged", this.currentPage + 1);
            },
            onClickLastPage() {
                this.$emit("pagechanged", this.totalPages);
            },
            isPageActive(page) {
                return this.currentPage === page;
            },
        },
    };
</script>

<style scoped>
    .disabled {
        cursor: not-allowed;
    }

    a {
        cursor: pointer;
    }

    .displayNone {
        display: none;
    }

    @media screen and (max-width: 523px) {
        ul {
            display: flex;
            flex-wrap: wrap;
        }
    }

</style>